import { setTerms } from './helpers';

export const setHouseLineForShoppingArea = setTerms('building_house_line_type__shopping_area');
